import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=2f4e3610&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"
import style0 from "./Agents.vue?vue&type=style&index=0&id=2f4e3610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e3610",
  null
  
)

export default component.exports